import { render, staticRenderFns } from "./ClocksEntry.vue?vue&type=template&id=688c21c0&"
import script from "./ClocksEntry.vue?vue&type=script&lang=js&"
export * from "./ClocksEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports